import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LoginUser } from '../models/login-user';
import { ApiResponse } from '../models/api-response';
import { UserMenuNodes } from '../models/user-menu-nodes';

import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { AppConfigService } from '../app-config.service.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private uri = "";//`${environment.apiBaseUrl}`;
  private urlAI = "";
  private baseurlUtility = "";
  public currentUserName = new BehaviorSubject<string>('');
  public isClient = new BehaviorSubject<boolean>(false);
  public apiBaseUrlUtility= ""
  // public settings: BehaviorSubject() = {
    // dateFormat: '',
    // moneyFormat: '',
    // startPage: ''
  // }

  public settings = new BehaviorSubject<any>({
    dateFormat: '',
    moneyFormat: '',
    startPage: '',
    layout: '',
    map: '',
    regionid: '',
    languageid: ''
  })

  constructor(private http: HttpClient, private router: Router,
    private appConfigService: AppConfigService
    ) {
      this.uri = appConfigService.appConfigJson.apiBaseUrl;
      // this.baseurlUtility = appConfigService.appConfigJson.baseurlUtility;
      this.baseurlUtility = appConfigService.apiBaseUrlUtility;
      this.apiBaseUrlUtility = this.appConfigService.apiBaseUrlUtility;

      this.urlAI = appConfigService.appConfigJson.urlAI;
  }
  login(loginUser: LoginUser) {
    if (this.uri != 'https://flexapi.cube-usa.com'){
      alert('Alert! Your are tryig to login to a NO Production environment. If you are sure that is not an error you can go.');
    }
    return this.http.post<ApiResponse>(this.uri + '/user', loginUser);
  }

  autologin(email: string) {
    return this.http.post<ApiResponse>(this.uri + '/user', { username: email, password: '', remember: '' } );
  }


  autoLoginUserTemp(email: string) {
    return this.http.post<any>(this.baseurlUtility + '/user', { username: email, password: '', remember: '' } );
  }

  getMenu() {
    
    return this.http.post<UserMenuNodes[]>(this.uri + '/UserMenu', {});
  }

  changePassword(pass) {
    
    let email = localStorage.getItem('email');
    return this.http.post<any>(this.uri + '/User/ChangePassword', {
      Email: email,
      Password: pass
    });
  }

  changePasswordCW(pass) {
    
    let email = localStorage.getItem('email');
    return this.http.post<any>(this.uri + '/User/ChangePasswordCW', {
      Email: email,
      Password: pass
    });
  }

  getZDUserToken() {
    
    return this.http.post<any>(this.uri + '/User/GetZendDeskToken', {});
  }

  getcubechatResponse(obj: any) {
    
    return this.http.post<any>(this.urlAI + '/cubeAI', obj);

  }

  getuserSetting() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_UserSettingsCE" });

  }

  updateuserSetting(obj: any) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);

  }

  getClientTypes() {
    
    return this.http.post<any>(this.uri + '/User/GetClientTypes', {});
  }

  createDatabase(clientDatabase: string, clientID: number) {
    
    return this.http.post<any>(this.uri + '/User/CreateDatabase', { clientdatabase: clientDatabase, clientid: clientID });
  }

  createCompleteDatabase(data: any) {
    console.log(this.apiBaseUrlUtility);
    return this.http.post<any>(this.apiBaseUrlUtility + '/Payment/createPaymentNC', data);
  }

  recoverPassword(email) {
    
    return this.http.post<any>(this.uri + '/User/RecoverPassword', {
      Email: email
    });
  }

  recoverPasswordCW(email) {
    
    return this.http.post<any>(this.uri + '/User/RecoverPasswordCW', {
      Email: email
    });
  }

  saveUserSettingCoor(userSetting: any) {
    
    userSetting.method = "update_UserSettingsCoor";
    let user = JSON.parse(userSetting.usersettings)
    if(user && user.regionid){
      userSetting.regionid = user.regionid;
    }
    console.log(userSetting);
    return this.http.post<any>(this.uri + '/FlexIntegration', userSetting);
  }

  saveUserSettingCoorMaster(userSetting: any) {
    
    userSetting.method = "update_UserSettingsCoorMaster";
    let user = JSON.parse(userSetting.usersettings)
    if(user && user.regionid){
      userSetting.regionid = user.regionid;
    }
    console.log(userSetting);
    return this.http.post<any>(this.uri + '/FlexIntegration', userSetting);
  }

  Get_ClientUserStartPagesCE() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_ClientUserStartPagesCE'
    });
  }

  Get_UserSettingsCE(userid) {
    // 
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_UserSettingsCE'
    });
  }

  Get_CubeWorksLogin(user: any) {
    
    return this.http.post<any>(this.uri + '/user/LogincubeWorks', user);
  }

  GetUserClients() {
    return this.http.post<any>(this.uri + '/User/GetUserCompanies', {});
  }

  UpdateUserDefaultClient(dbid: number) {
    
    return this.http.post<any>(this.uri + '/User/updateDefaultCompany', { dbid: dbid });
  }

  activateUser(Email: string) {
    
    return this.http.post<any>(this.uri + '/User/ActivateUser', { Email: Email });
  }

  acceptTerms(Email: string) {
    
    return this.http.post<any>(this.uri + '/User/AccepTerm', { Email: Email });
  }

  getUserAvaliableGroups(userID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getUserAvaliableGroups", currentuserid: userID });
  }

  getUserAssignedGroups(userID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getUserAssignedGroups", currentuserid: userID });
  }

  getReportsAvaliableGroups(groupID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getGroupAvaliableReports", groupid: groupID });
  }

  getReportsAssignedGroups(groupID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getGroupAssignedReports", groupid: groupID });
  }

  getDashboardsAvaliableGroups(groupID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getGroupAvaliableDashboard", groupid: groupID });
  }

  getDashboardsAssignedGroups(groupID: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "getGroupAssignedDashboard", groupid: groupID });
  }

  getGroupNav(GroupID: number) {
    
    console.log({ method: "Get_GroupToNavByGroupId", usergroupid: GroupID });
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_GroupToNavByGroupId", usergroupid: GroupID });
  }

  changeUserNav(navIDs: string, groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "changeUserNav", navids: navIDs, groupid: groupid });
  }

  getUsers() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_AllUser" });
  }

  getGroups() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_UserGroups" });
  }

  deleteUserToGroup(groupids: string, userid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "deleteUserToGroup", userid: userid, groupids: groupids });
  }

  insertUserToGroup(groupids: string, userid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "insertUserToGroup", currentuserid: userid, groupids: groupids });
  }

  async asyncInsertUserToGroup(groupids: string, userid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "insertUserToGroup", currentuserid: userid, groupids: groupids });
  }

  async asyncDeleteUserToGroup(groupids: string, userid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "deleteUserToGroup", userid: userid, groupids: groupids });
  }

  deleteReportToGroup(reportids: string, groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "deleteGroupToReport", groupid: groupid, reportids: reportids });
  }

  insertReportToGroup(reportids: string, groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "insertGroupToReport", groupid: groupid, reportids: reportids });
  }

  deleteDashboardToGroup(dashboardids: string, groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "deleteGroupToDashboard", groupid: groupid, dashboardids: dashboardids });
  }

  insertDashboardToGroup(dashboardids: string, groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "insertGroupToDashboard", groupid: groupid, dashboardids: dashboardids });
  }

  getUserInUserGroup(groupid: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_UserInUserGroups", groupid: groupid });
  }

  createUser(email: string, password: string) {
    
    return this.http.post(this.uri + '/User/InsertUser', { "Email": email, "Password": password })
  }

  getEmployees() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_EmployeeListAll" });
  }

  getGroupsAll() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_UserGroups" });
  }

  insertGroup(id: string, groupname: string) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "InsertUpdate_UserGroups", id: id, groupname: groupname });
  }

  deleteGroup(id: string) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Delete_UserGroups", id: id });
  }

  insertContact(contact: any) {
    
    return this.http.post<any>(this.uri + '/public/insertcontacce', contact );
  }

  insertCompany(company: any) {
    
    return this.http.post<any>(this.uri + '/public/InsertUser', company );
  }

  insertExtUsr(contact: any) {
    
    return this.http.post<any>(this.uri + '/User/extusr', contact );
  }  

  insertClient(company: any) {
    return this.http.post<any>(this.uri + '/User/InsertClient', company );
  }

  getCustomers() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_CustomerCE" });
  }

  createClientUser(email: string, userfirstname: string, userlastname: string, employeeid: number, isvendor: number, isclient: number, isemployee: number) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "InsertClientUser", email: email, userfirstname: userfirstname, userlastname: userlastname, employeeid: employeeid, isvendor: isvendor, isclient: isclient, isemployee: isemployee });
  }

  sendUserConfirm(email: string) {
    
    return this.http.post<any>(this.uri + '/User/SendUserConfirm', { Email: email } );
  }

  getUserAll() {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_UserAll" });
  }

  getUserExternalUser(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "GetExternal_UserAll" });
  }

  getClients(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_ClientCustomer" });
  }

  insertUser(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  updateUserStatus(userID: number, userActive: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "updateUserStatus", luserid: userID, active: userActive });
  }

  updateUserStatusLock(userID: number, userActive: number) {
    
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "updateUserStatusLock", luserid: userID, active: userActive });
  }

  updateExtUserStatusLock(id: number, locked: number){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "updateUserStatusLockExtUsr", luserid: id , islocked: locked });
  }

}
